import React, {Component} from 'react'

class BlogIndex extends Component {
    render() {
        return (
            <div>
                Blog Index
            </div>
        )
    }
}

export default BlogIndex